import { createActionGroup, props } from '@ngrx/store';

import { ErrorModel } from '@rocksoft/shared';

import {
  AppleProfilePresetAddType,
  AppleProfilePresetType,
  PresetAddModelType,
  PresetModelType,
} from './apple-profile-preset.types';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const AppleProfilePresetResolverActions = createActionGroup({
  source: 'Apple Profile Preset Resolver',
  events: {
    'Presets requested': props<{ profileType: AppleProfilePresetType }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const AppleProfilePresetViewActions = createActionGroup({
  source: 'Apple Profile Preset View',
  events: {
    'Preset added': props<{
      profileType: AppleProfilePresetAddType;
      preset: PresetAddModelType<AppleProfilePresetAddType>;
    }>(),
    'Preset updated': props<{
      profileType: AppleProfilePresetType;
      originalPreset: PresetModelType<AppleProfilePresetType>;
      preset: PresetModelType<AppleProfilePresetType>;
    }>(),
    'Preset deleted': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
    }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const AppleProfilePresetApiActions = createActionGroup({
  source: 'Apple Profile Preset API',
  events: {
    'Presets loaded': props<{
      profileType: AppleProfilePresetType;
      presets: PresetModelType<AppleProfilePresetType>[];
    }>(),
    'Presets loaded error': props<{
      profileType: AppleProfilePresetType;
      error: ErrorModel;
    }>(),
    'Preset added': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
    }>(),
    'Preset added error': props<{
      profileType: AppleProfilePresetAddType;
      preset: PresetAddModelType<AppleProfilePresetAddType>;
      error: ErrorModel;
    }>(),
    'Preset updated': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
    }>(),
    'Preset updated error': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
      error: ErrorModel;
    }>(),
    'Preset deleted': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
    }>(),
    'Preset deleted error': props<{
      profileType: AppleProfilePresetType;
      preset: PresetModelType<AppleProfilePresetType>;
      error: ErrorModel;
    }>(),
  },
});
